<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div>
    <app-pageheader [Parent]="this">
      @if (Model.ViolationStatus === 'Pending' || Model.ViolationStatus === 'Vacated without Action') {
        <button class="button is-primary"
          (click)="openActionViolationModal()"
          [disabled]="Model.ViolationStatus === 'Actioned'">
          Action Violation
        </button>
      }
    </app-pageheader>
    <div class="columns is-multiline">
      <div class="column is-6">
        <article class="panel" style="min-height: 30vh;">
          <p class="panel-heading">
            Violation Details
          </p>
          <a class="panel-block">
            <span class="label">Start Date</span>
            <span class="value">{{Model.ParkingStartDateLocalFriendlyString}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Violation began</span>
            <span class="value">{{Model.StartDateLocalFriendlyString}}</span>
          </a>
          @if (Model.EndDateLocalFriendlyString) {
            <a class="panel-block">
              <span class="label">Violation ended</span>
              <span class="value">{{Model.EndDateLocalFriendlyString || 'N/A'}}</span>
            </a>
          }
          @if (Model.DurationFriendlyString) {
            <a class="panel-block">
              <span class="label">Duration</span>
              <span class="value">{{Model.DurationFriendlyString || 'N/A'}}</span>
            </a>
          }
          <a class="panel-block">
            <span class="label">Status</span>
            <span class="value">
              <span class="tag" style="color:white;" [style.background-color]="enforcementService.getViolationStatusColor(Model.ViolationStatus)">{{Model.ViolationStatus}}</span>
              @if (Model.ViolationStatus === 'Actioned') {
                <span class="tag is-info ml-2">Actioned by: {{Model.ActionedByUserName}} on {{Model.ActionedDateLocalFriendlyString}}</span>
              }
            </span>
          </a>
          <a class="panel-block">
            <span class="label">Location</span>
            <span class="value">{{Model.ParkingSpaceLocationString}}</span>
          </a>
          @if (Model.ParkingSessionId) {
            <a class="panel-block">
              <span class="label">Parking Session</span>
              <span class="value">
                @if (Model.ParkingSessionId) {
                  <a routerLink="/parking/parkingsessions/{{Model.ParkingSessionId}}">{{Model.ParkingSessionId}}</a>
                }
                @if (!Model.ParkingSessionId) {
                  <span>N/A</span>
                }
              </span>
            </a>
          }
          @if (Model.PlateNumber) {
            <a class="panel-block">
              <span class="label">Plate Number</span>
              <span class="value">{{Model.PlateNumber}}</span>
            </a>
          }
          @if (Model.TicketReference) {
            <a class="panel-block">
              <span class="label">Ticket Reference</span>
              <span class="value">
                <span class="tag"  style="color:black;">Assigned Ticket #{{Model.TicketReference}}</span>
              </span>
            </a>
          }
        </article>
      </div>
      <div class="column is-6">
        <app-structureviewermaps [Layers]="StructureViewerLayers" [SearchTerm]="StructureSearchTerm"
        [StructureId]="StructureId" [StructureViewerForType]="StructureViewerForType"></app-structureviewermaps>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Notes
          </p>
          <div class="panel-block">
            {{Model.Notes ?? 'No notes available'}}
          </div>
        </article>
      </div>
    </div>
  </div>
}